import { paidPostCSVColumn, shopPostCSVColumn } from './topPostsCSVColumns';
import { buildExportFilename, downloadItemsAsCSV } from 'utils/formatCSV';
import DownloadButton from '../Button/DownloadButton';
import { useEndDate } from 'utils/hooks';

function TopPostsDownloadButton({
    name,
    country,
    source,
    topPostsQuery,
    visibleOrderedMetrics,
    csvColumns,
}) {
    const date = useEndDate(source);
    return (
        <DownloadButton
            onClick={() => {
                downloadItemsAsCSV(
                    buildExportFilename({
                        entity: name,
                        country,
                        source,
                        type: 'top-posts',
                        kind: 'data',
                        date,
                    }),
                    topPostsQuery.data,
                    csvColumns || [
                        { key: 'url', label: 'Post' },
                        paidPostCSVColumn,
                        shopPostCSVColumn,
                        {
                            key: 'sentiment_summary',
                            label: 'Sentiment Summary (AI-generated)',
                        },
                        { key: 'sentiment_score', label: 'Sentiment' },
                        ...visibleOrderedMetrics.map(
                            ({ key, tableHeadColumnLabel: label }) =>
                                key === 'last_week_views'
                                    ? { key, label: 'Views' }
                                    : { key, label },
                        ),
                    ],
                );
            }}
            disabled={!topPostsQuery.data?.length}
            fetching={topPostsQuery.isLoading}
            mixpanelContext="TopPostsDownload"
        />
    );
}

export default TopPostsDownloadButton;
